import { AppInitializer } from '../app-init';
import { KeycloakService } from 'keycloak-angular';
import { EnvConfig, EnvironnementManager } from '@wizeoo/akm-common-lib';

export function initializeKeycloak(keycloak: KeycloakService, appInitialize: AppInitializer ) {
  return async () => {


    // chargement de l'environnement si nécessaire
    await EnvironnementManager.checkEnvConfig().then(
      async response => { return Promise.resolve()}
    );

    let env: EnvConfig = EnvironnementManager.envConfig;
    // console.log(' EnvironnementManager initializeKeycloak', env)


    const client = env.client;
    const realm = window.location.hostname.split('.')[0];

    const inited = await keycloak.init({
      config: {
        url: env.keycloakUrl,
        realm,
        clientId: client,
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + env.specifHref["base"] + '/assets/silent-check-sso.html',
      },
      bearerExcludedUrls: ['/api/keycloak/config'],
    });

    if (inited) {
      return appInitialize.init();
    } else {
      return Promise.resolve();
    }
  };
}
